import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';

import { useYupValidationResolver } from 'hooks/useYupValidationResolver';
import {
    func, objectOf, shape, string,
} from 'prop-types';

export const withForm = ({
    Component, schema, stepName, selector, validations,
}) => (defProps) => {
    const { [stepName]: defaultValues } = useSelector(
        selector,
    );

    const validationSchema = validations
        ? schema(validations) : schema;

    const {
        handleSubmit, formState: { errors }, setValue, watch, trigger, setError,
    } = useForm({
        resolver: useYupValidationResolver(validationSchema),
        shouldUnregister: false,
        defaultValues,
    });

    const onChange = useCallback((type) => async (e) => {
        setValue(type, e.target?.value ?? e);
        await trigger(type);
    }, [setValue, trigger]);

    const formProps = useMemo(() => ({
        errors,
        values: watch,
        onChange,
        setValue,
        handleSubmit,
        setError,
        trigger,
    }), [errors, watch, onChange, setValue, handleSubmit, setError, trigger]);

    return (
        <Component
            {...defProps}
            formProps={formProps}
        />
    );
};

export const withFormPropType = shape({
    errors: objectOf(shape({
        type: string,
        message: string,
    })),
    values: func.isRequired,
    onChange: func.isRequired,
    setValue: func.isRequired,
    handleSubmit: func.isRequired,
    trigger: func.isRequired,
});
